module.exports = __webpack_public_path__ + "img/bigpackfast-inactive.1455ab68.svg";